import Header from 'containers/header'
import SearchBar from 'containers/search-bar'
import VideoDetail from '../components/video-detail'
import Page from './page'

const VideoDetailPage = () => (
    <Page>
        <Header />
        <SearchBar />
        <VideoDetail />
    </Page>
)

export default VideoDetailPage
